import { RoundingRuleRangeDTO } from '../dto';
import { RoundingTFunction } from '@retail/rounding/i18n';

export type RoundingMode = 'KEEP' | 'ROUND_UP' | 'CLOSEST';

export interface RoundingRuleRangeProps {
  priceFrom: number;
  priceTo?: number;
  roundingMode: RoundingMode;
  targetEndings?: number[];
}

export class RoundingRuleRange {
  priceFrom: number;
  priceTo?: number;
  roundingMode: RoundingMode;
  targetEndings?: number[];

  constructor(props: RoundingRuleRangeProps) {
    this.priceFrom = props.priceFrom;
    this.priceTo = props.priceTo;
    this.roundingMode = props.roundingMode;
    this.targetEndings = props.targetEndings;
  }

  getPriceRuleString = (t: RoundingTFunction): string => {
    switch (this.roundingMode) {
      case 'KEEP':
        return t('rounding.keep');
      case 'ROUND_UP':
        return t('rounding.upTo');
      case 'CLOSEST':
        return t('rounding.closest');
    }
  };

  toDto = (): RoundingRuleRangeDTO => ({
    priceFrom: this.priceFrom,
    priceTo: this.priceTo,
    roundingOption: this.roundingMode,
    targetEndings: this.targetEndings,
  });

  static fromDto(dto: RoundingRuleRangeDTO): RoundingRuleRange {
    return new RoundingRuleRange({
      priceFrom: dto.priceFrom,
      priceTo: dto.priceTo,
      roundingMode: dto.roundingOption,
      targetEndings: dto.targetEndings,
    });
  }
}
